import styled, { css, keyframes } from 'styled-components';

import { ButtonBack } from '@pkg/components/Sections/Profile/Buttons';

const HEADER_HEIGHT = 112;
const PADDING_HEIGHT = 80;
const HEADER_PADDING = HEADER_HEIGHT + PADDING_HEIGHT;
const MODAL_FULLSCREEN_LIMIT = 450;

export const Wrapper = styled.div<{ contentHeight?: number }>`
    top: 1px;
    left: 1px;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    border-radius: 30px;
    overflow: hidden;
    position: absolute;
    background: radial-gradient(196.37% 108.65% at 36.25% 32.5%, #1d1b2b 0%, #090719 100%);

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        border-radius: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;

        ${({ contentHeight }) =>
            contentHeight &&
            contentHeight < MODAL_FULLSCREEN_LIMIT &&
            css`
                border-radius: 30px 30px 0 0;
                top: 1px;
                left: 0;
                width: calc(100% - 1px);
                height: calc(100% - 2px);
            `};
    }
`;

const open = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

const openMobile = keyframes`
    0% {
        transform: translate(0%, 30%);
        opacity: 0;
    }

    100% {
        transform: translate(0%, 0%);
        opacity: 1;
    }
`;

const close = keyframes`
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
`;

const closeMobile = keyframes`
    0% {
        transform: translate(0%, 0%);
        opacity: 1;
    }

    100% {
        transform: translate(0%, 30%);
        opacity: 0;
    }
`;

export const Outer = styled.div<{ isFaded: boolean; contentHeight?: number }>`
    background: linear-gradient(
        105deg,
        rgba(90, 90, 90, 1) 0%,
        #302d3d 17%,
        #302d3d 22%,
        rgba(60, 60, 60, 1) 27%,
        #302d3d 32%,
        #302d3d 90%,
        #302d3d 100%
    );
    z-index: 2;
    position: fixed;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 580px;
    max-height: 954px;
    height: 90vh;
    top: 50%;
    border-radius: 30px;
    opacity: 0;

    ${({ contentHeight }) =>
        contentHeight &&
        contentHeight < MODAL_FULLSCREEN_LIMIT &&
        css`
            height: ${contentHeight + HEADER_PADDING}px;
        `};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        animation: ${open} 0.2s ease-in-out;
        animation-fill-mode: forwards;
        ${({ isFaded }) =>
            isFaded &&
            css`
                animation: ${close} 0.2s ease-out;
                animation-fill-mode: forwards;
            `};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        top: unset;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform: translate(0%, 30%);
        max-height: unset;
        border-radius: 0;
        animation: ${openMobile} 0.2s ease-in-out;
        animation-fill-mode: forwards;
        ${({ isFaded }) =>
            isFaded &&
            css`
                animation: ${closeMobile} 0.2s ease-out;
                animation-fill-mode: forwards;
            `};

        ${({ contentHeight }) =>
            contentHeight &&
            contentHeight < MODAL_FULLSCREEN_LIMIT &&
            css`
                border-radius: 30px 30px 0 0;
                height: ${contentHeight + HEADER_PADDING}px;
            `};
    }
`;

export const HeaderWrapper = styled.div`
    height: 112px;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
`;

export const HeaderBorder = styled.div`
    height: 1px;
    width: 100%;
    position: relative;
    background: linear-gradient(
        105deg,
        #302d3d 17%,
        #302d3d 32%,
        rgba(90, 90, 90, 1) 55%,
        #302d3d 62%,
        #302d3d 90%,
        #302d3d 100%
    );
`;

export const InnerContent = styled.div`
    height: calc(100% - 113px);
`;

export const Heading = styled.h3`
    color: ${({ theme }) => theme.colors.white};
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 25px;
    line-height: 32px;
    letter-spacing: -1px;
    padding-left: 42px;
    padding-right: 90px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding-left: 24px;
    }
`;

export const BackButton = styled(ButtonBack)`
    height: 56px !important;
    width: 56px !important;
    position: absolute !important;
    top: 24px;
    right: 21px;
`;
